
import { DataClass } from "./DataClass";

/*
 * @author: xd
 * @Date: 2022-06-25 13:27:15
 * @LastEditors: xd
 * @LastEditTime: 2022-06-25 14:28:20
 * @FilePath: \httpvue\src\utils\system.ts
 * @Description: 
 * 
 * Copyright (c) 2022 by xd, All Rights Reserved. 
 */
export class system {
    SYPANO: DataClass;
    tykg: DataClass;
    SYKFGL: DataClass;
    SYWWBH: DataClass;
    SYBGGL: DataClass;
    SYCWGL: DataClass;
    SYDAGL: DataClass;
    SYKYGL: DataClass;
    SYRSGL: DataClass;
    SYXMGL: DataClass;
    SYYHGL: DataClass;
    SYZCGL: DataClass;
    SYTSGL: DataClass;
    SYKTXM: DataClass;
    SYXBDXZHUZ: DataClass;

    constructor(mUrl:string) {
        this.SYPANO = new DataClass({ url: mUrl,pid: "SYPANO", appid: "27208914" });
        this.tykg = new DataClass({url: mUrl, pid: "tykg", appid: "16884957" });
        this.SYKFGL = new DataClass({url: mUrl,pid: "SYKFGL", appid: "92837277" });
        this.SYWWBH = new DataClass({url: mUrl, pid: "SYWWBH", appid: "92837277" });
        this.SYBGGL = new DataClass({url: mUrl, pid: "SYBGGL", appid: "92837277" });
        this.SYCWGL = new DataClass({url: mUrl, pid: "SYCWGL", appid: "92837277" });
        this.SYDAGL = new DataClass({url: mUrl, pid: "SYDAGL", appid: "92837277" });
        this.SYKYGL = new DataClass({url: mUrl, pid: "SYKYGL", appid: "92837277" });
        this.SYKFGL = new DataClass({url: mUrl, pid: "SYKFGL", appid: "92837277" });
        this.SYRSGL = new DataClass({url: mUrl, pid: "SYRSGL", appid: "92837277" });
        this.SYXMGL = new DataClass({url: mUrl, pid: "SYXMGL", appid: "92837277" });
        this.SYYHGL = new DataClass({url: mUrl, pid: "SYYHGL", appid: "92837277" });
        this.SYZCGL = new DataClass({url: mUrl, pid: "SYZCGL", appid: "92837277" });
        this.SYTSGL = new DataClass({url: mUrl, pid: "SYTSGL", appid: "92837277" });
        this.SYKTXM = new DataClass({url: mUrl, pid: "SYKTXM", appid: "92837277" });
        this.SYXBDXZHUZ = new DataClass({url: mUrl, pid: "SYXBDXZHUZ", appid: "92837277" });
    }


}